// extracted by mini-css-extract-plugin
export default {"statistic":"survey-answers_statistic__q8kpv","question-container":"survey-answers_question-container__suPzG"};